<template>
    <div>
        <!-- EMPRESAS LISTADAS NA TABELA/DETALHES -->
        <b-modal id="modal-log-detalhado"
            ref="modalLogDetalhado"
            title="Log detalhado"
            size="lg"
            no-close-on-esc
            no-close-on-backdrop
            ok-only
            ok-title="fechar"
            scrollable
            v-drag>
                <el-card v-loading="loading" class="box-card w-100">
                    <b-card class="w-100 mb-2">
                        <b-row>
                            <b-col cols="4">
                                <p class="p-0 m-0"> <small>Cluster: </small> <b><i>{{ modalData.cluster ? modalData.cluster.nome : '' }}</i></b> </p>
                            </b-col>

                            <b-col cols="4">
                                <p class="p-0 m-0"> <small>Inicio: </small> <b><i>{{ modalData.inicio }}</i></b> </p>
                            </b-col>

                            <b-col cols="4">
                                <p class="p-0 m-0"> <small>Fim: </small> <b><i>{{ modalData.fim }}</i></b> </p>
                            </b-col>
                            <el-button v-if="modalData.notas" class="cursor-pointer" icon="el-icon-warning-outline" circle size="mini" type="danger" @click.native="showNotas(modalData.notas)" style="position: absolute;right: 5px;top: 7px;"></el-button>
                        </b-row>
                    </b-card>
                    <el-form :model="model" ref="formWebservice" size="mini" label-position="top">
                        <b-card class="w-100 mb-2">
                            <b-form-row>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Status:" label-align-sm="left" label-size="sm">
                                        <b-form-select v-model="model.StatusResponse" size="sm" class="form-control-sm">
                                            <option value="0">Todos</option>
                                            <option value="1">Sucesso</option>
                                            <option value="2">Erro</option>
                                        </b-form-select>
                                    </b-form-group>
                                </b-col>
                                <b-col cols="12" md="6">
                                    <b-form-group label="Data início/fim:" label-align-sm="left" label-size="sm">
                                        <el-date-picker v-model="model.datas"
                                                        type="daterange"
                                                        range-separator="|"
                                                        start-placeholder="Início"
                                                        end-placeholder="Fim"
                                                        format="dd/MM/yyyy"
                                                        size="small"
                                                        class="w-100 mb-2">
                                        </el-date-picker>
                                    </b-form-group>
                                </b-col>
                            </b-form-row>
                            <b-form-row class="mb-2">
                                <template>
                                    <div class="col-lg-12 col-md-12">
                                        <el-form-item label="Empresa:" label-for="empresas">
                                            <select2-multiple :options="listas.empresas" name="empresas" v-model="model.EmpresasIds" :url="$urls.EMPRESAS"></select2-multiple>
                                        </el-form-item>
                                    </div>
                                </template>
                                
                            </b-form-row>
                            <div>
                                <div class="float-right btn-pesquisar">
                                    <b-button style="width:150px;" @click.prevent="filtrarLogs" variant="success" size="sm" class="mr-2">Filtrar</b-button>
                                </div>
                            </div>
                        </b-card>
                    </el-form>
                    <div class="container-overflow-empresas"> 
                        <!-- TABLE -->
                        <el-table
                            :data="modalData.logs"
                            stripe
                            size="mini"
                            :show-overflow-tooltip="false">
                            <el-table-column
                                prop="dataDaPesquisa"
                                label="Data da pesquisa"
                                width="150">
                            </el-table-column>
                            <el-table-column
                                prop="empresa"
                                label="Empresa"
                                width="150">
                            </el-table-column>
                            <el-table-column
                                prop="mensagem"
                                label="Mensagem">
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-footer class="text-center" style="padding-top:13px;">
                        <el-pagination
                            class="text-center"
                            background
                            layout="prev, pager, next, sizes"
                            @size-change="paginacaoSize"
                            @current-change="paginacaoCurrent"
                            :page-size="pagination.pageSizeLogs"
                            :current-page.sync="pagination.pageLogs"
                            :total="modalData.qtdeLogs"
                            :page-sizes="[5, 10, 25, 50]">
                        </el-pagination>
                    </el-footer>
                </el-card>
        </b-modal>
    </div>
</template>

<script>

import Select2Multiple from '@/components/shared/Select2Multiple';

const model = () => {
    return {
        Inicio: '',
        Fim: '',
        datas: '',
        EmpresasIds: [],
        StatusResponse: "0"
    }
}

const listas = () => {
    return {
        empresas: []
    }
}

export default {
    components: {
        Select2Multiple
    },
    data(){
        return {
            modalData: {},
            model: model(),
            listas: listas()
        }
    },
    name: 'modal-log-detalhes',
    props:['datas','pagination','loading'],
    methods:{
        computedClass(index) {
            if (index % 2 === 0) {
                return "col-md-4"
            }
        },
        showNotas(numero, notas) {
            const notasHtml = () => {
                let html = '';
                for(let i = 0; i < notas.length; i++){
                    html += `<p>${notas[i]}</p>`;
                }
                return html;
            }
            let htmlFormated = `<div class="row">
                        <div class="col-md-12">
                            ${notasHtml()}
                        </div>
                        <div>`;
            this.$alert(htmlFormated, 'Notas', { dangerouslyUseHTMLString: true });
        },
        cellStyle(row) {
            if(row.columnIndex === 0){
                return !row.row.notas ? 'remove-controle-notas' : '';
            }
            
        },
        filtrarLogs(){
            this.$root.$emit('filtrarLogs', { id: this.modalData.id, f: this.model })
        },
        paginacaoCurrent(val){
            this.$root.$emit('paginationDetalheCurrent', { id: this.modalData.id, p: val, f: this.model });
        },
        paginacaoSize(val){
            this.$root.$emit('paginationDetalheSize', { id: this.modalData.id, p: val, f: this.model });
        }
    },
    watch: {
        datas: {
            deep: true,
            handler(dt){
                this.modalData = dt;
            }
        },
        'model.datas': function(val) {
            let hasVal = !this.isNullOrEmpty(val);

            this.model.Inicio = hasVal ? this.moment(val[0]).format('YYYY-MM-DD') : ''
            this.model.Fim = hasVal ? this.moment(val[1]).format('YYYY-MM-DD') : ''
        }
    }
}
</script>
<style lang="scss">
    .card-empresas-container{
        max-height:250px; 
        overflow-y:auto; 
        width:100%;
        &::-webkit-scrollbar-track{
            box-shadow: inset 0 0 6px rgba(54, 54, 54, 0.3);
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar{
            width: 6px;
            background-color: #F5F5F5;
        }
        &::-webkit-scrollbar-thumb{
            background-color: #5e5e5e;
        }
    }
    .filtro-empresas{
        padding: 0px;
        margin: 5px 0;
        margin-top: -9px;
    }
    .card-empresas{
        transition:0.2s;
        padding: 5px 6px !important;
        cursor: pointer;
        .el-card {
            padding: 3px;
        }
        .selected {
            background: #7dbde2 !important;
        }
        &:hover{
            background:#f1f1f1;
        }
    }
    .table-lista-empresas{
        tr{
            &:nth-child(odd){
                background: #fff;
            }
            &:nth-child(even){
                background: #f4fafd;
            }
        }
    }
    td.remove-controle-notas {
        opacity: 0;
        visibility: hidden;
    }
    #modal-log-detalhado .el-table .cell {
        overflow: inherit !important;
        text-overflow: inherit !important;
        white-space: inherit !important;
    }
</style>